import PhotoSwipe from 'photoswipe/dist/photoswipe.min'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min'

/* Function */
const initPhotoSwipeFromDOM = gallerySelector => {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.querySelectorAll("figure"),
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;


        for (let i = 0; i < numNodes; i++) {
            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes
            if (figureEl.nodeType !== 1) {
                continue;
            }

            if (figureEl.classList.contains("w-video")) {
                linkEl = figureEl.querySelector("a[data-video]");
            } else {
                linkEl = figureEl.children[0]; // <a> element
            }

            size = linkEl.getAttribute("data-size").split("x");

            // create slide object
            if (linkEl.getAttribute("data-type") === "video") {
                item = {
                    html: linkEl.getAttribute("data-video")
                };
            } else {
                item = {
                    src: linkEl.getAttribute("href"),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };
            }

            if (figureEl.classList.contains("w-video")) {
                // <figcaption> content
                item.title = figureEl.querySelector("caption")
                    ? figureEl.querySelector("caption").innerHTML
                    : null;
            } else if (figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML;
            }

            if (linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute("src");
            }

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    let closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    let onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);

        let eTarget = e.target || e.srcElement;

        // find root element of slide
        let clickedListItem = closest(eTarget, function(el) {
            return el.tagName && el.tagName.toUpperCase() === "FIGURE";
        });

        if (!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        let clickedGallery = findClosest(clickedListItem, gallerySelector),
            childNodes = findClosest(
                clickedListItem,
                gallerySelector
            ).querySelectorAll("figure"),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (let i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }

            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };

    function findClosest(el, selector) {
        let matchesFn;

        // find vendor prefix
        [
            "matches",
            "webkitMatchesSelector",
            "mozMatchesSelector",
            "msMatchesSelector",
            "oMatchesSelector"
        ].some(function(fn) {
            if (typeof document.body[fn] === "function") {
                matchesFn = fn;
                return true;
            }
            return false;
        });

        let parent;

        // traverse parents
        while (el) {
            parent = el.parentElement;
            if (parent && parent[matchesFn](selector)) {
                return parent;
            }
            el = parent;
        }

        return null;
    }

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    let photoswipeParseHash = function() {
        let hash = window.location.hash.substring(1),
            params = {};

        if (hash.length < 5) {
            return params;
        }

        let vars = hash.split("&");
        for (let i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            let pair = vars[i].split("=");
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    let openPhotoSwipe = function(
        index,
        galleryElement,
        disableAnimation,
        fromURL
    ) {
        let pswpElement = document.querySelectorAll(".pswp")[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute("data-pswp-uid"),

            showHideOpacity: true,
            clickToCloseNonZoomable: false,
            shareEl: true,
            zoomEl: true,
            closeOnScroll: false,
            fullscreenEl: false,
            history: false,
            counterEl: true,
            showAnimationDuration: 0
            /*getThumbBoundsFn: function(index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    let thumbnail = items[index].el, // find thumbnail
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                }*/
        };

        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for (let j = 0; j < items.length; j++) {
                    if (items[j].pid === index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        gallery.listen("beforeChange", function() {
            const currItem = gallery.currItem.container;

            const iframes = document.querySelectorAll("iframe");

            if (iframes) {
                iframes.forEach(iframe => {
                    iframe.classList.remove("active");
                });

                const currItemIframe = currItem.querySelector("iframe");

                if (currItemIframe) {
                    currItemIframe.classList.add("active");
                }

                iframes.forEach(iframe => {
                    if (!iframe.classList.contains("active")) {
                        iframe.setAttribute("src", iframe.getAttribute("src"));
                    }
                });
            }
        });

        gallery.listen("close", function() {
            const iframes = document.querySelectorAll("iframe");
            iframes.forEach(iframe => {
                iframe.setAttribute("src", iframe.getAttribute("src"));
            });
        });

        gallery.init();
    };

    // loop through all gallery elements and bind events
    let galleryElements = document.querySelectorAll(gallerySelector);

    for (let i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute("data-pswp-uid", i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    let hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }

    //function hasClass(element, className) {
    //  return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
    //}
};

/* Init photoSwipe */
initPhotoSwipeFromDOM("[js-program-plan]");
initPhotoSwipeFromDOM("[js-program-slider]");
